import type { MailboxInfo } from 'owa-client-types';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import type { OutlookCloudPolicySettingId } from '../store/schema/OutlookCloudPolicyTypes';
import { isPoliciesEnabledForAccount } from '../utils/isPoliciesEnabledForAccount';
import { getPolicyDataBySettingId } from './getPolicyDataBySettingId';

type EnabledIfUndefined = boolean | (() => boolean);

export function isOcpsPolicyEnabled(
    settingId: OutlookCloudPolicySettingId,
    mailboxInfo?: MailboxInfo,
    enabledIfUndefined?: EnabledIfUndefined
): boolean {
    const resolvedMailboxInfo = mailboxInfo ?? getModuleContextMailboxInfo();
    if (!isPoliciesEnabledForAccount(resolvedMailboxInfo)) {
        return resolveEnabledIfUndefined(enabledIfUndefined, true);
    }
    const policyData = getPolicyDataBySettingId(resolvedMailboxInfo, settingId);
    return policyData
        ? policyData.value === '1'
        : resolveEnabledIfUndefined(enabledIfUndefined, false);
}

function resolveEnabledIfUndefined(
    enabledIfUndefined: EnabledIfUndefined | undefined,
    defaultValue: boolean
): boolean {
    return typeof enabledIfUndefined === 'function'
        ? enabledIfUndefined()
        : (enabledIfUndefined ?? defaultValue);
}
